"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

var _jsxruntime = require('react/jsx-runtime');

var n = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "ChevronRightIconSmall",
  size: "Small",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M7.73657 3.11113L7.11104 3.73705C6.96299 3.88519 6.96299 4.1254 7.11104 4.27358L12.82 10L7.11104 15.7264C6.96299 15.8746 6.96299 16.1148 7.11104 16.2629L7.73657 16.8889C7.88461 17.037 8.12467 17.037 8.27275 16.8889L14.889 10.2683C15.037 10.1201 15.037 9.87992 14.889 9.73174L8.27275 3.11113C8.12467 2.96296 7.88461 2.96296 7.73657 3.11113Z"
  }),
  svgElements: ["path"]
}),
    C = exports.b = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "ChevronRightIconExtraSmall",
  size: "ExtraSmall",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M5.55262 2.0796L5.08351 2.5267C4.97216 2.63283 4.97216 2.80445 5.08351 2.91058L9.36466 7L5.08351 11.0894C4.97216 11.1956 4.97216 11.3672 5.08351 11.4733L5.55262 11.9204C5.66397 12.0265 5.84403 12.0265 5.95538 11.9204L10.9165 7.19194C11.0278 7.08581 11.0278 6.91419 10.9165 6.80806L5.95538 2.0796C5.84403 1.97347 5.66397 1.97347 5.55262 2.0796Z"
  }),
  svgElements: ["path"]
}),
    a = exports.c = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "ChevronRightIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M11.9207 6.14289L11.1388 6.94763C10.9537 7.13811 10.9537 7.44695 11.1388 7.63746L18.275 15L11.1388 22.3625C10.9537 22.553 10.9537 22.8618 11.1388 23.0524L11.9207 23.8571C12.1058 24.0476 12.4058 24.0476 12.5909 23.8571L20.8612 15.3449C21.0463 15.1545 21.0463 14.8456 20.8612 14.6551L12.5909 6.14289C12.4058 5.95237 12.1058 5.95237 11.9207 6.14289Z"
  }),
  svgElements: ["path"]
});

exports.a = n;
exports.b = C;
exports.c = a;